import i18n from "src/locales/index";

export const gameTypeTranslate = (gameTypeName) => {
  // If the name contains Hebrew characters, return the original name for compatibility with old names.
  if (/[א-ת]/.test(gameTypeName)) return gameTypeName;

  const translationKey = gameTypeName.replace(/\s+/g, '_').toLowerCase();
  const key = `gameTypes.${translationKey}`;

  // Check if the translation exists.
  if (i18n.te(key)) {
    return i18n.t(key);  // Return the translated name.
  }
  console.warn(`Missing translation for key: ${key}`);
  return gameTypeName;  // Return the original name if no translation is found.
}
